import styles from "./Footer.module.css";
import { BsTwitterX, BsSteam, BsYoutube } from "react-icons/bs";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <div className={styles.footer}>
      <div className={styles.left}>
        <div className={styles.legalColumn}>
          <Link to="/tos">Terms of Service</Link>
          <Link to="/privacy-policy">Privacy Policy</Link>
        </div>
      </div>
      <div className={styles.middle}>
        <div className={styles.linksRow}>
          <a
            href="https://steamcommunity.com/profiles/76561198079420041"
            target="_blank"
            rel="noopener noreferrer"
          >
            <BsSteam />
          </a>
          <a
            href="https://x.com/steedie"
            target="_blank"
            rel="noopener noreferrer"
          >
            <BsTwitterX />
          </a>
          <a
            href="https://www.youtube.com/@Steedie"
            target="_blank"
            rel="noopener noreferrer"
          >
            <BsYoutube />
          </a>
        </div>
      </div>
      <div className={styles.right}></div>
    </div>
  );
}

export default Footer;
